import { z } from 'zod';

export const getValidator = (visibleFields: ('email' | 'password')[]) => {
  const emailValidator = z
    .string({ required_error: 'The email address field is required.' })
    .email('Invalid email address.');
  const passwordValidator = z
    .string({ required_error: 'The password field is required.' })
    .min(8, 'Password must be at least 8 characters.');
  return z.object({
    email:
      visibleFields.indexOf('email') > -1
        ? emailValidator
        : emailValidator.optional(),
    password:
      visibleFields.indexOf('password') > -1
        ? passwordValidator
        : passwordValidator.optional(),
    dob: z.string().optional(),
    zip: z.string().optional().nullable(),
    acceptedTOS: z.boolean().optional(),
    state: z.string().optional().nullable(),
    disableInstantBrandTransfer: z.boolean().optional(),
    emailOnly: z.boolean().optional(),
  });
};

export type FormSchemaType = z.infer<ReturnType<typeof getValidator>>;

export const FORM_CONFIG: {
  [Property in 'email' | 'password']: {
    label: string;
    name: Property;
    type: string;
    placeholder: string;
    autoComplete?: string;
  };
} = {
  email: {
    label: 'Email',
    name: 'email',
    type: 'email',
    placeholder: 'janedoe@email.com',
    autoComplete: 'email',
  },
  password: {
    label: 'Password',
    name: 'password',
    type: 'password',
    placeholder: 'Create a password',
  },
};

export type VisibleFormSchemaType = Partial<
  Pick<FormSchemaType, 'email' | 'password'>
>;

export type VisibleFieldType = keyof VisibleFormSchemaType;

export type VisibleErrors = Record<VisibleFieldType, string>;
